/** @jsxImportSource davaux/client */
import { reactive } from 'davaux'
import { createSignal } from 'davaux/client'

function CloseIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 16 16'
      width='1em'
      height='1em'
      fill='none'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
    >
      <path d='M3 3l10 10M13 3L3 13' />
    </svg>
  )
}

function Drawer({
  opened = false,
  title,
  body = '',
  triggerLabel,
  position = 'left',
  size = 'md',
}: {
  opened?: boolean
  title?: string
  body?: string
  triggerLabel?: string
  position?: 'top' | 'right' | 'bottom' | 'left'
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full'
}) {
  const [open, setOpen] = createSignal(opened)

  function close() {
    setOpen(false)
  }

  function handleRootKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape') close()
  }

  return (
    <div class='dv-drawer-root'>
      {triggerLabel && (
        <button
          type='button'
          class='dv-drawer-trigger dv-button'
          data-variant='filled'
          onClick={() => setOpen(true)}
        >
          {triggerLabel}
        </button>
      )}
      <div
        class='dv-drawer'
        data-opened={() => open() || undefined}
        data-position={position}
        onKeyDown={handleRootKeyDown}
      >
        <div class='dv-drawer-overlay' onClick={close} aria-hidden='true' />
        <div class='dv-drawer-content' data-size={size} role='dialog' aria-modal='true'>
          <div class='dv-drawer-header'>
            {title && <span class='dv-drawer-title'>{title}</span>}
            <button type='button' class='dv-drawer-close' onClick={close} aria-label='Close'>
              <CloseIcon />
            </button>
          </div>
          <div class='dv-drawer-body' dangerouslySetInnerHTML={{ __html: body }} />
        </div>
      </div>
    </div>
  )
}

export default reactive(Drawer)
